import { useCallback, useState } from "react"

import { toggle as toggleItem } from "shared/lib/arrayUtils"
import { exists } from "shared/lib/exists"

export function useArrayState<T>(initialValue?: T[]) {
  const [array, setArray] = useState(initialValue || [])

  const add = useCallback((item: T) => {
    setArray(prev => {
      if (!prev.includes(item)) {
        return [...prev, item]
      }
      return prev
    })
  }, [])

  const remove = useCallback((item: T) => {
    setArray(prev => prev.filter(i => i !== item))
  }, [])

  const toggle = useCallback((item: T) => {
    setArray(prev => toggleItem(item, prev))
  }, [])

  const move = useCallback(
    (
      item: T,
      from: number | null | undefined,
      to: number | null | undefined
    ) => {
      setArray(prev => {
        const prevClone = [...prev]

        if (exists(from)) {
          prevClone.splice(from, 1)
        }
        if (exists(to)) {
          prevClone.splice(to, 0, item)
        }

        return prevClone
      })
    },
    []
  )

  return {
    array,
    setArray,
    add,
    remove,
    toggle,
    move
  }
}
